import { __assign, __extends } from "tslib";
import * as _ from '@antv/util';
import Annotation from './base';
var Region = /** @class */ (function (_super) {
    __extends(Region, _super);
    function Region(cfg) {
        /* istanbul ignore next */
        return _super.call(this, __assign({ type: 'region', zIndex: 1, start: null, end: null, style: {
                lineWidth: 0,
                fill: '#CCD7EB',
                opacity: 0.4,
            } }, cfg)) || this;
    }
    Region.prototype.render = function (coord, group) {
        var rectStyle = this.get('style');
        var path = this.getPath(coord);
        var regionGroup = group.addShape('path', {
            zIndex: this.get('zIndex'),
            attrs: _.assign({
                path: path,
            }, rectStyle),
        });
        regionGroup.name = 'annotation-region';
        this.get('appendInfo') &&
            regionGroup.setSilent('appendInfo', this.get('appendInfo'));
        this.set('el', regionGroup);
    };
    Region.prototype.getPath = function (coord) {
        var start = this.parsePoint(coord, this.get('start'));
        var end = this.parsePoint(coord, this.get('end'));
        return [
            ['M', start.x, start.y],
            ['L', end.x, start.y],
            ['L', end.x, end.y],
            ['L', start.x, end.y],
            ['z'],
        ];
    };
    return Region;
}(Annotation));
export default Region;
//# sourceMappingURL=region.js.map